import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerStmtExpService } from '../owner-stmt-exp.service';
import { OwnerStmtExp } from '../owner-stmt-exp';

@Component({
    selector: 'app-owner-stmt-exp',
    templateUrl: './owner-stmt-exp.component.html',
    styleUrls: ['./owner-stmt-exp.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerStmtExpComponent implements OnInit {
	properties: any;
	ownerStmtId: any;
	ownerStmtIdRequired: boolean;
	ownerStmtList: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private ownerStmtExpService: OwnerStmtExpService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.ownerStmtId = data.ownerStmtId,
			this.ownerStmtExp = data.ownerStmtExp,
			this.statuses = ownerStmtExpService.statuses;
			this.formReadOnly = true;
	}

	@Input() ownerStmtExp: OwnerStmtExp;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ownerStmtExpId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	formReadOnly = false;

	statuses: any;

	validationMessages = {
		'ownerStmtExpId': [],
		'expenseDate': [],
		'name': [],
		'description': [],
		'ownerNotes': [],
		'opsNotes': [],
		'reservationId': [],
		'shortTermRentalId': [],
		'ownerStmtId':[], //ParentId here
		showToStmt:[]

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ownerStmtExp object
		if (this.ownerStmtExp) {
			// this.formReadOnly = true;
			this.ownerStmtExpId = this.ownerStmtExp.ownerStmtExpId;
			this.fixDates();
			this.form1.patchValue(this.ownerStmtExp);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ownerStmtExpId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.form1.value.ownerStmtId = this.ownerStmtId;

			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ownerStmtExpService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerStmtExp = res.data.ownerStmtExp;
						this.doAdd.emit(this.ownerStmtExp);
					},
					(err: any) => {
						console.log('ownerStmtExp-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ownerStmtExp: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
		//	this.form1.value.ownerStmtId = this.ownerStmtId;
			this.ownerStmtExpService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ownerStmtExp = res.data.ownerStmtExp;
						this.doUpdate.emit(this.ownerStmtExp);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ownerStmtExpService.delete(this.ownerStmtExp.ownerStmtExpId)
				.subscribe(
					(res: any) => {
						console.log('ownerStmtExp-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ownerStmtExp);
					},
					(err: any) => {
						console.log('ownerStmtExp-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ownerStmtExpId: [this.ownerStmtExpId],
      expenseDate: [],
			closeDate: [],
			name: [],
			description: [],
			ownerNotes: [],
			opsNotes: [],
			reservationId: [],
			shortTermRentalId: [],
			ownerStmtId: [this.ownerStmtId],
			showToStmt:[]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ownerStmtExp.expenseDate = moment(this.ownerStmtExp.expenseDate).toDate();
	}

	selectOwnerStmtExp(){
		this.ownerStmtIdRequired = false;
	}

	fetchOwnerStmt() {
			try {
				this.ownerStmtExpService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.ownerStmtList = res.data.ownerStmts;
							return this.ownerStmtList;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}
}
